import { Component, OnInit } from '@angular/core';

import { ApiInfoService } from 'app/services';
import { VERSION } from '../../../environments/version';

@Component({
  selector: 'app-version-info',
  templateUrl: './version-info.component.html',
  styleUrls: ['./version-info.component.scss'],
})
export class VersionInfoComponent implements OnInit {
  infoDataApi: any;
  infoDataDashboard: any;

  constructor(private readonly apiInfoService: ApiInfoService) {}

  ngOnInit() {
    this.apiInfoService.findApiInfo().subscribe((response) => {
      const infos: {[key: string]: string} = {};
      Object.keys(response).forEach(
          (key)=> {
          infos[key] = JSON.parse(JSON.stringify(response[key], undefined, 4));
      });
      this.infoDataApi = infos;
      this.infoDataDashboard = JSON.parse(JSON.stringify(VERSION, undefined, 4));
    });
  }
}
